import React from "react";
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
const Handle = Slider.Handle;
class WizardItemSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.data.Answer,
      touched: false,
      isKeyboardInteraction: false
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onInputChangeStart = this.onInputChangeStart.bind(this);
    this.onInputChangeComplete = this.onInputChangeComplete.bind(this);
    this.formatLabel2 = this.formatLabel2.bind(this);
    this.handle = this.handle.bind(this);
  }

  componentDidMount(props) {
    if (this.props.data.Answer) {
      this.props.submitAnswer(this.props.data.Answer);
    }
  }

  handle (props) {
    const { value, dragging, index, ...restProps } = props;
    return (
      <Tooltip
        prefixCls={ "rc-slider-tooltip"}
        overlay={this.formatLabel2()}
        visible={ (this.props.currentStep === (this.props.data.CurrentItem-1)) ? true : false}
        placement="top"
        key={index}
      >
        <Handle 
          value={value} 
          {...restProps}
          />
      </Tooltip>
    );
  }

  onInputChange(val) {
    let nextState = {value:val}
    if (!this.state.touched) {
      nextState.touched = true;
    }
    this.setState(nextState);
  }
  
  onInputChangeStart(e) {
    this.setState({touched:true});
  }

  onInputChangeComplete() {
    let val = this.state.value;
    const value = Math.round(val);
    this.setState({ value: value });
    this.props.submitAnswer(value);
  }

  formatLabel2() {
    const roundValue = Math.round(this.state.value);
    const unit = this.props.data.UnitLabel
      ? " " + this.props.data.UnitLabel
      : "";
    let str = `${roundValue} ${unit}`;

    if (
      this.props.data.HasRangeMaxValuePlusSign &&
      roundValue === this.props.data.RangeMaxValue
    ) {
      str = `${roundValue}+ ${unit}`;
    }
    return str;
  }
  
  render() {
    let isTouched = this.state.touched;
    return (
      <div
        className={
          (isTouched ? "" : "untouched ") + "wizard-item wizard-item__slider"
        }
      >
        <div>
        <input type="hidden" data-trackingid={this.props.data.QuestionTrackingId} value={this.state.value} />
          <Slider 
            step={0.01}
            min={this.props.data.RangeMinValue}
            max={this.props.data.RangeMaxValue} 
            defaultValue={3} 
            handle={this.handle} 
            onChange={this.onInputChange }
            onBeforeChange={this.onInputChangeStart }
            onAfterChange={this.onInputChangeComplete}
            value={this.state.value}
          />
        </div>
      </div>
    );
  }
}

export default WizardItemSlider;
